import { render } from "./HomepageSectionEdit.vue?vue&type=template&id=4476337a&scoped=true"
import script from "./HomepageSectionEdit.vue?vue&type=script&lang=js"
export * from "./HomepageSectionEdit.vue?vue&type=script&lang=js"

import "./HomepageSectionEdit.vue?vue&type=style&index=0&id=4476337a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4476337a"]])

export default __exports__